import React from "react";
import PropTypes from "prop-types";
import {SFNavTabs, SFNavTab } from "../tabBar";
import SFCard, { SFCardHeader, SFCardBody } from "../card";
import { SFStack } from "../grid";
import getStyled from "../../hooks/getStyled";
import { hasPermission } from "../authorized";
import { Outlet } from "react-router-dom";

const { styled } = getStyled();

const StyledCard = styled(SFCard)(({ theme, fillpage }) => ({
  marginTop: theme.spacing(1),
  overflow: "unset",
  display: "flex",
  flexDirection: "column",
  flexGrow: fillpage === "true" ? 1 : 0,
  "& .MuiCardHeader-root": {
    borderBottom: `1px solid ${theme.palette.grey225.main}`,
  },
  "& .MuiTabs-flexContainer": {
    paddingLeft: theme.spacing(2),
  },
  "& .MuiTab-root": {
    paddingRight: 0,
    paddingLeft: 0,
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
  },
}));

const SFCardBodyStyled = styled(SFCardBody)(({ fillpage }) => ({
  padding: "0px !important",
  flexGrow: fillpage === "true" ? 1 : 0,
}));


const SFNavTabsCard = ({ tabs, fillPage }) => {
  return (
    <StyledCard fillpage={fillPage.toString()}>
      <SFCardHeader
        sx={{
          p: 0,
        }}
        title={
          <SFStack justifyContent="space-between">
            <SFNavTabs>
              {tabs
                .filter((x) => hasPermission(x.permissions))
                .map((tab, index) => (
                  <SFNavTab
                    label={tab.label}
                    key={index}
                    path={tab.path}
                  ></SFNavTab>
                ))}
            </SFNavTabs>
          </SFStack>
        }
      />
      <SFCardBodyStyled fillpage={fillPage.toString()}>
        <Outlet></Outlet>
      </SFCardBodyStyled>
    </StyledCard>
  );
};

SFNavTabsCard.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node)
};

export default SFNavTabsCard;
